var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
export default (function (_a) {
    var className = _a.className, color = _a.color, htmlAttributes = __rest(_a, ["className", "color"]);
    return (React.createElement("svg", __assign({ width: "24px", height: "24px", viewBox: "0 0 24 24", version: "1.1", style: { fill: 'none' }, className: className }, htmlAttributes),
        React.createElement("g", { id: "----Icons", stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" },
            React.createElement("g", { id: "Custom-Icons-/-RadioButton-Active", fill: color ? color : 'currentColor' },
                React.createElement("g", { id: "Icon-Circle" },
                    React.createElement("path", { d: "M12,23 C18.0751323,23 23,18.0751323 23,12 C23,5.92486773 18.0751323,0.999999954 12,0.999999954 C5.92486773,0.999999954 0.999999954,5.92486773 0.999999954,12 C0.999999954,18.0751323 5.92486773,23 12,23 Z M12,21 C7.02943723,21 2.99999996,16.9705628 2.99999996,12 C2.99999996,7.02943723 7.02943723,2.99999996 12,2.99999996 C16.9705628,2.99999996 21,7.02943723 21,12 C21,16.9705628 16.9705628,21 12,21 Z", id: "Shape" })),
                React.createElement("circle", { id: "Oval", cx: "12", cy: "12", r: "7.5" })))));
});
